<template>
  <div>
    <v-data-table v-if="items.length > 0" :items="items" :headers="headers">
      <template v-slot:item="props">
        <tr>
          <td
            v-for="(header, index) in headers"
            :key="index"
            :class="
              all(props.index)
                ? 'red lighten-1'
                : propRequired(header.value, props.index)
            "
          >
            <span>{{ props.item[header.value] }}</span>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>
<script>
export default {
  props: {
    items: {
      default: () => [],
      type: Array,
    },
    properties: {
      default: () => [],
      type: Array,
    },
  },
  data: () => ({
    headers: [
      {
        text: "EmpCode",
        value: "empCode",
        sortable: false,
      },
      {
        text: "Name",
        value: "name",
        sortable: false,
      },
      {
        text: "Tax Basic",
        value: "taxBasic",
        sortable: false,
      },
      {
        text: "NTaxBasic",
        value: "nTaxBasic",
        sortable: false,
      },
      {
        text: "Daily Rate",
        value: "dailyRate",
        sortable: false,
      },
      {
        text: "Hourly Rate",
        value: "hourlyRate",
        sortable: false,
      },
      {
        text: "Start Date",
        value: "startDate",
        sortable: false,
      },
      {
        text: "Basic Salary Update Reason",
        value: "basicSalaryUpdateReason",
        sortable: false,
      },
    ],
  }),
  computed: {},
  methods: {
    propRequired(prop, index) {
      var result = this.properties.filter((item) => {
        return (
          item.property.toLowerCase() == prop.toLowerCase() &&
          item.index == index &&
          item.mode == "BASICSAL"
        );
      });

      if (result.length > 0) return "red lighten-1";
      else return "";
    },
    all(index) {
      var result = this.properties.filter((item) => {
        return (
          item.property == "ALL" &&
          item.mode == "BASICSAL" &&
          item.index == index
        );
      });
      if (result.length > 0) return true;
      else false;
    },
  },
};
</script>
